// Чистые проверки лимитов количества модификатора (без store/Pinia).
// Используются карточкой ModifiersCombo и комбо-движком. Перенесено из useModifiersCore.

export const canIncreaseModifier = (modifier: any, currentAmount: number, groupMaxAmount?: number, currentGroupAmount?: number): boolean => {
	if (groupMaxAmount && groupMaxAmount > 0 && currentGroupAmount !== undefined) {
		const totalAfterAdd = currentGroupAmount + currentAmount + 1;
		if (totalAfterAdd > groupMaxAmount) return false;
	}

	const modifierMax = modifier.max_amount;
	if (modifierMax && modifierMax > 0 && currentAmount >= modifierMax) return false;

	return true;
};

export const canDecreaseModifier = (currentAmount: number, minAmount?: number): boolean => {
	if (minAmount && minAmount > 0) {
		return currentAmount > minAmount;
	}
	return currentAmount > 0;
};
